<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { page } from '$app/stores';
	import FastBtn from '$lib/component/fast-btn.svelte';
	import Footer from '$lib/component/footer.svelte';
	import Navbar from '$lib/component/navbar.svelte';
	import Partner from '$lib/component/partner.svelte';
	import { initHeroHomeSwiper } from '$lib/js/script.js';
	import { onMount } from 'svelte';

	import type { PageServerData } from './$types';
	export let data: PageServerData;

	const lang = $page.params.locale;

	let partner = data?.partner;
	let otherroom = data?.otherroom;
	let detail = data?.roomdetail;
	let award = data?.award;

	console.log(detail);

	onMount(() => {
		initHeroHomeSwiper();

		const script = document.createElement('script');
		script.src = 'https://unpkg.com/@phosphor-icons/web';
		script.async = true;
		document.head.appendChild(script);

	});
</script>

<svelte:head>
	<title>{detail.name} - Holiday Inn Resort Bali Nusa Dua</title>
	<link rel="canonical" href="https://balinusadua.holidayinnresorts.com/en/rooms/{detail.slug}">
</svelte:head>

<Navbar />

<FastBtn />

<section id="rooms">
	<div id="hero-banner" class="container-fluid p-0">
		<div class="w-100 h-100 p-md-0 p-0 position-relative overflow-hidden">
			<img
				alt="Holiday Inn Resorts Nusa Dua"
				src={detail.featured_images[0].path}
				class="img-header"
			/>
			<div id="hero-text" class="position-absolute top-0 start-0 w-100 h-100">
				<!-- <div class="row g-0 w-100 h-100 justify-content-center align-items-center">
					<div class="col-md-6 text-center text-white p-3">
						<h1 class="ff-lola-bir display-3 mb-3">{detail.name}</h1>
					</div>
				</div> -->
			</div>
		</div>
	</div>

	<div class="container-fluid py-md-5 py-5 px-0 rooms-welcome position-relative">
		<div class="container px-md-0 px-3">
			<div class="row g-0 justify-content-center align-items-start mt-md-5 mt-4 mb-md-5 mb-5">
				<div class="col-md-4 pe-md-5 ">
					<p class="mb-md-3 main-color display-5 pe-md-3 ff-lola-bir lh-2">{detail.name}</p>
					<p class="line mb-md-4 mb-3"></p>
					<p class="ff-helvetica mb-0">
						<span class="badge fs-6 fw-light main-badge ff-helvetica me-2 mb-2 px-4 py-2"
							><i class="align-middle ph ph-arrows-out-simple me-1"></i> {detail.feature.size}</span
						>
						<span class="badge fs-6 fw-light main-badge ff-helvetica me-2 mb-2 px-4 py-2"
							><i class="align-middle ph ph-bed me-1"></i> {detail.feature.bed}</span
						>
						<span class="badge fs-6 fw-light main-badge ff-helvetica me-2 mb-2 px-4 py-2"
							><i class="align-middle ph ph-users me-1"></i> {detail.feature.occupancy}</span
						>
						<span class="badge fs-6 fw-light main-badge ff-helvetica me-2 mb-2 px-4 py-2"
							><i class="align-middle ph ph-binoculars me-1"></i> {detail.feature.view}</span
						>
					</p>
				</div>
				<div class="col-md-8 ps-md-5">
					<div class="ff-helvetica">{@html detail.description}</div>
					<p><a data-sveltekit-reload href="https://www.ihg.com/holidayinnresorts/hotels/us/en/find-hotels/select-roomrate?fromRedirect=true&qSrt=sBR&qIta=99502222&icdv=99502222&qSlH=DPSBB&qRms=1&qAdlt=1&qChld=0&qCiD=03&qCiMy=02025&qCoD=04&qCoMy=02025&qAAR=6CBARC&qRtP=6CBARC&setPMCookies=true&qSHBrC=HI&qDest=Jl%20Pratama,%20No%2086,%20Tanjung%20Benoa,%20Bali,%20ID&srb_u=1&qChAge=&qRmFltr=" target="_blank" class="btn main-btn text-uppercase ff-lola-mr px-4 py-2">{$_('btn_book')}</a></p>
				</div>
			</div>
		</div>
		<div class="mt-md-5">
			<div class="swiper slider-img-room position-relative">
				<div class="swiper-wrapper">
					{#each detail.featured_images as img}
						<div class="swiper-slide">
							<div class="ratio-21x7">
								<img alt="Holiday Inn Resort Nusa Dua" src={img.path} class="w-100 h-100 object-fit-cover" />
							</div>
						</div>
					{/each}
				</div>

				<div
					class="nav-slider-img-room position-absolute top-0 start-0 w-100 h-100 rounded-4 d-flex align-items-center justify-content-between z-3 p-md-5 p-3"
				>
					<span
						class="btn btn-light text-dark border-0 rounded-circle btn-prev d-flex align-items-center justify-content-center me-2"
						><i class="ph-light ph-caret-left"></i></span
					>
					<span
						class="btn btn-light text-dark border-0 rounded-circle btn-next d-flex align-items-center justify-content-center"
						><i class="ph-light ph-caret-right"></i></span
					>
				</div>
			</div>
		</div>
	</div>

	<div class="container rooms-amenities pb-md-5 pb-4">
		<div class="row g-0 align-items-center">
			<div class="col-md-6 pe-md-4">
				<div class="ratio ratio-1x1">
					<img alt="Holiday Inn Resort Nusa Dua" src={detail.featured_images[1].path} class="w-100 h-100 object-fit-cover" />
				</div>
			</div>
			<div class="col-md-6 ps-md-4">
				<p class="mb-md-2 mb-3 main-color fs-1 pe-md-3 ff-lola-bir mt-md-5 mt-3 lh-2">
					{$_('rd_in_room')}
				</p>
				<p class="line-2 mb-md-5 mb-3"></p>
				<div class="col-md-12 row g-0 align-items-center">
					{#each detail.facilities as facility}
						<div class="col-md-6 col-12 d-flex align-items-center pe-3 pb-3">
							<div class="icon p-2 me-2 fs-5">
								{@html facility.icon}
							</div>
							<span class="main-color ff-lola-bir ms-1 lh-1"> {facility.name} </span>
						</div>
					{/each}
				</div>
			</div>
			<div class="col-md-8 pe-md-4">
				<p class="mb-md-2 mb-3 main-color fs-1 pe-md-3 ff-lola-bir mt-md-5 mt-3 lh-2">{$_('rd_room_tips')}</p>
				<p class="line-2 mb-md-5 mb-3"></p>
				<div class="ff-helvetica">
					{@html detail.room_tips}
				</div>
			</div>
			<div class="col-md-4 ps-md-4">
				<div class="ratio ratio-1x1">
					<img alt="Holiday Inn Resort Nusa Dua" src={detail.featured_images[0].path} class="w-100 h-100 object-fit-cover" />
				</div>
			</div>
		</div>
	</div>

	<div class="container-fluid py-md-5 py-5 px-md-5 px-3 position-relative">
		<div class="row g-0 align-items-center">
			<div class="col-md-12 row g-0 mb-md-4 mb-3 align-items-center align-items-md-end">
				<div class="col-md-9 col-7">
					<p class="mb-md-2 mb-3 main-color fs-1 pe-md-3 ff-lola-bir mt-md-5 mt-3 lh-2">
						{$_('rd_other_room')}
					</p>
					<p class="line-2 mb-md-0"></p>
				</div>
				<div class="col-md-3 col-5 text-end">
					<div class="nav-slider-room d-flex align-items-center justify-content-end">
						<span
							class="btn btn-prev d-flex align-items-center justify-content-center me-3 rounded-circle"
							><i class="ph-light ph-caret-left"></i></span
						>
						<span
							class="btn btn-next d-flex align-items-center justify-content-center rounded-circle"
							><i class="ph-light ph-caret-right"></i></span
						>
					</div>
				</div>
			</div>
			<div class="col-md-12">
				<div class="swiper slider-other-room">
					<div class="swiper-wrapper">
						{#each otherroom as room}
							<div class="swiper-slide slide-main">
								<div class="d-none d-md-block">
									<div class="swiper slider-img-room position-relative">
										<div class="swiper-wrapper">
											{#each room?.featured_images as img}
												<div class="swiper-slide">
													<div class="ratio-5x6 rounded-4">
														<img alt="Holiday Inn Resort Nusa Dua" src={img.path} class="w-100 h-100 object-fit-cover rounded-4" />
													</div>
												</div>
											{/each}
										</div>

										<div
											class="nav-slider-img-room position-absolute top-0 start-0 w-100 h-100 rounded-4 d-flex align-items-end justify-content-between z-3 p-3"
										>
											<div class="m-1 position-relative text-white" style="width:13%">
												<div class="swiper-pagination"></div>
											</div>
											<div class="d-flex">
												<span
													class="btn btn-outline-light btn-prev d-flex align-items-center justify-content-center me-2"
													><i class="ph-light ph-caret-left"></i></span
												>
												<span
													class="btn btn-outline-light btn-next d-flex align-items-center justify-content-center"
													><i class="ph-light ph-caret-right"></i></span
												>
											</div>
										</div>
									</div>

									<div class="row g-0 mt-3">
										<div class="col-md-8">
											<p class="mb-3 main-color fs-4 ff-lola-bir lh-2">
												{room?.name}
											</p>
											<div class="ff-helvetica">
												<p class="mb-1">
													<i class="ph-light ph-ruler fs-5 me-2 align-middle"></i>
													{room?.feature?.size}
												</p>
												<p class="mb-1">
													<i class="ph-light ph-bed fs-5 me-2 align-middle"></i>
													{room?.feature?.bed}
												</p>
												<p class="mb-1">
													<i class="ph-light ph-binoculars fs-5 me-2 align-middle"></i>
													{room?.feature?.view}
												</p>
											</div>
										</div>
										<div class="col-md-4 text-end">
											<a
												data-sveltekit-reload
												href="/{lang}/rooms/{room.slug}"
												class="btn main-btn px-4 py-2 ff-helvetica d-none d-md-inline-block"
												>{$_('btn_view_details')}</a
											>
										</div>
									</div>
								</div>

								<div class="d-block d-md-none px-3">
									<a data-sveltekit-reload href="/rooms" class="text-decoration-none">
										<div class="ratio-5x6 rounded-4 position-relative">
											<img
												alt="Holiday Inn Resort Nusa Dua"
												src="/img/bg-home-1.jpg"
												class="w-100 h-100 object-fit-cover rounded-4"
											/>

											<div
												class="position-absolute bottom-0 start-0 w-100 p-3 rounded-4 pt-5"
												style="background-image: linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0.5), rgba(0,0,0,0))"
											>
												<div class="row g-0">
													<div class="col-12 text-white">
														<p class="mb-0 fs-1 ff-lola-bir lh-2">
															{room?.name}
														</p>
														<div class="ff-helvetica">
															<p class="mb-1">
																<i class="ph-light ph-ruler fs-5 me-2 align-middle"></i>
																{room?.feature?.size}
															</p>
															<p class="mb-1">
																<i class="ph-light ph-bed fs-5 me-2 align-middle"></i>
																{room?.feature?.bed}
															</p>
															<p class="mb-1">
																<i class="ph-light ph-binoculars fs-5 me-2 align-middle"></i>
																{room?.feature?.view}
															</p>
														</div>
													</div>
												</div>
											</div>
										</div>
									</a>
								</div>
							</div>
						{/each}
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<Partner {partner} />

<Footer award={award}/>

<style>
	#hero-text {
		background-color: rgba(0, 0, 0, 0.3);
	}
	.rooms-welcome::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		z-index: -1;
		margin-bottom: -2px;
		background-image: linear-gradient(
				to top,
				rgba(255, 255, 255, 1),
				rgba(255, 255, 255, 0.85),
				rgba(255, 255, 255, 0.8)
			),
			url('/img/bg-home-1.jpg');
		background-position: center;
		background-size: cover;
	}
	.line {
		border-bottom: 2px solid #451C70;
		width: 25%;
	}
	.line-2 {
		border-bottom: 2px solid #451C70;
		width: 15%;
	}
	.ratio-21x7 {
		aspect-ratio: 21/7;
	}
	.slider-img-room .nav-slider-img-room .btn-prev,
	.slider-img-room .nav-slider-img-room .btn-next {
		width: 50px;
		height: 50px;
		border-radius: 10px;
		border: 2px solid white;
		color: white;
		font-size: 26px;
		cursor: pointer;
		transition: 0.3s all;
	}
	.slider-img-room .nav-slider-img-room .btn-prev:hover,
	.slider-img-room .nav-slider-img-room .btn-next:hover {
		background-color: rgba(255, 255, 255, 0.3);
		transition: 0.3s all;
	}

	.nav-slider-room .btn-prev,
	.nav-slider-room .btn-next {
		border: 1px solid #451C70;
		color: #451C70;
		width: 50px;
		height: 50px;
		font-size: 24px;
		transition: 0.3s all;
	}
	.nav-slider-room .btn-prev:hover,
	.nav-slider-room .btn-next:hover {
		border: 1px solid #451C70;
		background-color: #451C70;
		color: white;
		transition: 0.3s all;
	}

	.slider-other-room .swiper-slide-active {
		transition: margin-left 0.3s ease; /* Tambahkan animasi jika diperlukan */
	}

	.rooms-amenities .icon {
		background-color: #ebe5ef;
		color: #451C70;
		border-radius: 100%;
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	@media (max-width: 600px) {
		.rooms-welcome .right-content-rooms:before {
			content: unset;
		}
		.rooms-welcome .slider-img-room .ratio-21x9 {
			aspect-ratio: 9/7 !important;
		}
		.ratio-21x7 {
			aspect-ratio: 1/1;
		}
	}
</style>
